import { render, staticRenderFns } from "./amount-form-modal.vue?vue&type=template&id=de0d2982&"
import script from "./amount-form-modal.vue?vue&type=script&lang=js&"
export * from "./amount-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports